<template>
  <v-flex xs12 class="ma-0">
    <div class="d-flex">
      <v-card class="card-curvey pa-3 elevation-0">
        <v-card-text class="pa-0">
          <v-layout align-center justify-center>
            <v-flex
              v-if="
                campaign &&
                campaign.status &&
                campaign.status !== 'DRAFT' &&
                campaign.status !== 'CANCELED' &&
                campaign.status !== 'SENT' &&
                campaign.status !== 'QUEUED'
              "
            >
              <v-btn
                class="ml-0 mr-0"
                style="
                  border-top-right-radius: 0;
                  border-bottom-right-radius: 0;
                "
                :disabled="campaign && campaign.status === 'SENDING'"
                :loading="loaders.resume"
                @click="resume"
              >
                <v-icon>play_arrow</v-icon>
                {{ campaign.status === "SCHEDULED" ? "Send Now" : "Resume" }}
              </v-btn>

              <v-btn
                class="mx-0"
                style="border-radius: 0"
                :disabled="campaign && campaign.status !== 'SENDING'"
                :loading="loaders.pause"
                @click="pause"
              >
                <v-icon>pause</v-icon>
                Pause
              </v-btn>

              <v-btn
                class="mx-0 mr-1"
                style="border-top-left-radius: 0; border-bottom-left-radius: 0"
                :disabled="campaign && campaign.status === 'CANCELED'"
                :loading="loaders.cancel"
                @click="cancel"
              >
                <v-icon>close</v-icon>
                Cancel
              </v-btn>
            </v-flex>
            <span v-if="isScheduled" class="warning--text px-1 font-weight-bold"
              >Scheduled for</span
            >

            <v-flex
              v-if="
                campaign &&
                (campaign.status === 'DRAFT' || campaign.status === 'SCHEDULED')
              "
              class="pa-0"
            >
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="date"
                lazy
                transition="scale-transition"
                min-width="290px"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="date"
                    readonly
                    outlined
                    style="width: 120px"
                    placeholder="Date"
                    :disabled="isScheduled && !rescheduleEnabled"
                    class=""
                    v-on="on"
                    label="Date"
                  />
                </template>
                <v-date-picker
                  v-model="date"
                  no-title
                  scrollable
                  :min="$moment().format('YYYY-MM-DD')"
                >
                  <v-btn flat color="primary" @click="menu = false"
                    >Cancel</v-btn
                  >
                  <v-btn flat color="primary" @click="$refs.menu.save(date)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>

              <v-menu
                ref="menuTime"
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="time"
                lazy
                transition="scale-transition"
                min-width="290px"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="time"
                    :class="[{ 'mr-1': campaign && schedule }]"
                    placeholder="Time"
                    readonly
                    outlined
                    style="width: 80px"
                    v-on="on"
                    label="Time"
                    :disabled="isScheduled && !rescheduleEnabled"
                  />
                </template>
                <v-time-picker
                  v-if="menu2"
                  v-model="time"
                  full-width
                  @click:minute="$refs.menuTime.save(time)"
                  outlined
                />
              </v-menu>

              <v-select
                v-model="timezone"
                :items="timezones"
                placeholder="Timezone"
                dense
                outlined
                label="Timezone"
                style="width: 150px"
                :disabled="isScheduled && !rescheduleEnabled"
              />

              <v-btn
                color="black"
                dark
                :loading="loaders.schedule"
                @click="scheduleCampaign"
                :disabled="isScheduled && !rescheduleEnabled"
                >{{ rescheduleEnabled ? "Reschedule" : "Schedule" }}</v-btn
              >
              <v-btn
                v-if="schedule"
                color="warning"
                @click="rescheduleEnabled = true"
                outline
                small
                dense
                :disabled="rescheduleEnabled"
              >
                Edit Schedule
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </div>
  </v-flex>
</template>

<script>
export default {
  name: "ScheduleCampaign",
  props: {
    campaign: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      time: null,
      menu2: false,
      timezone: null,
      rescheduleEnabled: false,
      timezones: ["Asia/Riyadh", "Asia/Qatar", "Asia/Dubai", "Africa/Cairo"],
      loaders: {
        resume: false,
        pause: false,
        stop: false,
        cancel: false,
        schedule: false,
      },
    };
  },
  computed: {
    campaignId() {
      return this.$route.params.id;
    },
    schedule() {
      if (!this.campaign) {
        return null;
      }
      return this.campaign.schedule;
    },
    isScheduled() {
      return !!(
        this.schedule &&
        this.campaign &&
        this.campaign.status === "SCHEDULED"
      );
    },
  },
  watch: {
    schedule: {
      immediate: true,
      handler(val) {
        if (val) {
          const timezone =
            val.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
          this.timezone = timezone;
          const dateObj = new Date(val.date);

          this.date = new Intl.DateTimeFormat("en-CA", {
            timeZone: timezone,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          }).format(dateObj);

          this.time = new Intl.DateTimeFormat("en-GB", {
            timeZone: timezone,
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          }).format(dateObj);
        }
      },
    },
  },
  methods: {
    async scheduleCampaign() {
      try {
        if (!this.date || !this.time || !this.timezone) {
          this.$store.dispatch(
            "setErrorMessage",
            "Please select Date, Time and Timezone."
          );
          return;
        }
        this.loaders.schedule = true;
        const timezone =
          this.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
        let date = this.$moment(`${this.date} ${this.time}`).format(
          "YYYY-MM-DDTHH:mm:ss"
        );

        await this.$http_session_manager.put(
          `/campaigns/${this.campaignId}/schedule`,
          {
            date,
            frequency: "daily",
            timezone,
          }
        );

        this.$emit("success");
        this.loaders.schedule = false;
        this.rescheduleEnabled = false;
      } catch (err) {
        this.loaders.schedule = false;
        throw err;
      }
    },
    async resume() {
      try {
        this.loaders.resume = true;
        await this.$http_session_manager.put(
          `/campaigns/${this.$route.params.id}/resume`
        );
        this.loaders.resume = false;
        this.$emit("updated");
        return true;
      } catch (err) {
        this.loaders.resume = false;
        throw err;
      }
    },
    async pause() {
      try {
        this.loaders.pause = true;
        await this.$http_session_manager.put(
          `/campaigns/${this.$route.params.id}/pause`
        );
        this.loaders.pause = false;
        this.$emit("updated");
        return true;
      } catch (err) {
        this.loaders.pause = false;
        throw err;
      }
    },
    async cancel() {
      try {
        this.loaders.cancel = true;
        await this.$http_session_manager.put(
          `/campaigns/${this.$route.params.id}/cancel`
        );
        this.loaders.cancel = false;
        this.$emit("updated");
        return true;
      } catch (err) {
        this.loaders.cancel = false;
        throw err;
      }
    },
  },
};
</script>

<style lang="css" scoped></style>
